module.exports = __webpack_public_path__ + "img/jerry-pro.472d2b82.jpg";